import React, { useContext} from "react";
import "./widgetcss/styles.css";
import { MapContext } from "../MapContext";

// Search widgeto elementas, css pakeiciamas priklausomai nuo aktyvumo
export default function SearchToGraphic () {

    const mapContext = useContext(MapContext);

      function enableSearchState () {
        
        
        mapContext.dispatch({
            searchFlag: 1,
        });  

        if (mapContext.state.searchToGraphic === false ){
            var element = document.getElementById("searchBtn");
            element.classList.add("Active");
        }
        if (mapContext.state.searchToGraphic === true) {
            
            var element = document.getElementById("searchBtn");
            element.classList.remove("Active");
        }

        mapContext.dispatch({
            searchToGraphic: !mapContext.state.searchToGraphic,
        });  
      }

      


    return (
        <>
         {mapContext.state.dateRange === null  ? <> </> : <button className="SearchBtn SidebarBtn ClearBtn " id="searchBtn" onClick={() => {enableSearchState()}}>Pasirinkti gatvę</button>}
         
        </>
    )
}